import React, { useState } from 'react';
import {
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import axios from 'axios';
import { useApi } from 'components/hooks/useApi';
import { useTenant } from 'components/hooks/useTenant';
import { useToken } from 'components/hooks/useToken';
import AddCategoryForm from "./addCategoryModal";

interface CategoriesMenuProps {
  refetchData: () => void;
  searchValue: string;
}

export default function CategoriesMenu({ refetchData, searchValue }: CategoriesMenuProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const toast = useToast();
  const apiUrl = useApi();
  const [multipleNames, setMultipleNames] = useState('');
  const token = useToken();
  const tenant = useTenant();
  const handleQuickAdd = async () => {
    if (!searchValue) {
      toast({
        title: 'No name found.',
        description: 'Please type something in the search bar to quick-add.',
        status: 'warning',
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    try {
      const requestBody = {
        Categories: [
          {
            name: searchValue,
          },
        ],
      };

      await axios.post(apiUrl+'/categories', requestBody, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tenant: tenant,
        },
      });

      toast({
        title: 'Category Added (Quick Add)',
        description: `Successfully added "${searchValue}"`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      refetchData();
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error creating category.',
        description: 'Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  const handleAddMultiple = async () => {
    try {
      const namesArray = multipleNames
        .split('\n')
        .map((n) => n.trim())
        .filter((n) => n !== '');

      const payload = {
        Categories: namesArray.map((name) => ({ name })),
      };
      await axios.post(apiUrl+'/categories', payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: {
          tenant: tenant,
        },
      });

      toast({
        title: 'Categories Added',
        description: `Successfully added ${namesArray.length} categories.`,
        status: 'success',
        duration: 3000,
        isClosable: true,
      });

      setMultipleNames('');
      onClose();
      refetchData();
    } catch (error) {
      console.error(error);
      toast({
        title: 'Error creating categories.',
        description: 'Please try again.',
        status: 'error',
        duration: 3000,
        isClosable: true,
      });
    }
  };

  return (
      <AddCategoryForm refreshCategories={refetchData} />
  );
}
